import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7da21ab6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "not-authorized"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "frontend-icon fi-fa_lock" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Auf diesen Inhalt haben Sie keinen Zugriff", -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = { class: "slide__navigation" }
const _hoisted_6 = { class: "slide__navigation_section" }
const _hoisted_7 = { class: "slide__navigation_section slide__navigation_section--center" }
const _hoisted_8 = { class: "slide__navigation_section slide__navigation_section--right" }
const _hoisted_9 = { class: "slide__image-container" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "slide__overlay" }, null, -1))
const _hoisted_11 = ["src"]

import { computed, onMounted, ref, toRefs } from 'vue';
  import { useStore } from 'vuex';
  import { cntProps } from 'vue/applications/frontend/mixins/cnt-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'cnt-slide_show',
  props: {...cntProps()},
  setup(__props) {

  const props = __props; 

  const store = useStore();
  const currentSlideIndex = ref<number>(0);
  const isFullscreen = ref<boolean>(false); 
  const root = ref<HTMLElement | null>(null);

  const currentSlidePosition = computed(() => currentSlideIndex.value + 1)
  const totalSlides = computed(() => props.contentItem.widget_data.slide_show.slide_show_slides.length);
  const currentSlide = computed(() => props.contentItem.widget_data.slide_show.slide_show_slides[currentSlideIndex.value])
  const classFullscreenIcon = computed(() => {
    const result: Record<string,boolean> = {
      "frontend-icon": true,
    };
    if (isFullscreen.value) {
      result["fi-fa_compress"] = true;
    } else {
      result["fi-fa_expand"] = true;
    }
    return result;
  });
  const notAuthorized = computed(() => {
    return (
      props.contentItem.widget_data.slide_show.needs_book_license &&
      !store.state.gon.user.has_book_license
    );
  });

  const navigate = (forward: boolean) => {
    if (forward && currentSlideIndex.value < totalSlides.value - 1) {
      currentSlideIndex.value += 1;
    } else if (!forward && currentSlideIndex.value > 0) {
      currentSlideIndex.value -= 1;
    }
  };
  const inputValue = ref(null);
  const navigateAbsolute = (event: InputEvent) => {
    const newValue = parseInt((event.target as HTMLInputElement).value, 10);
    inputValue.value = null; // remove value

    let targetIndex =
      newValue -
      1 +
      (props.contentItem.widget_data.slide_show.slide_position_offset || 0);

    // sanitize new index
    targetIndex = Math.min(targetIndex, totalSlides.value - 1);
    targetIndex = Math.max(targetIndex, 0);

    if (
      targetIndex <
      props.contentItem.widget_data.slide_show.slide_position_offset
    )
      targetIndex = 0;

    currentSlideIndex.value = targetIndex;
  }; 
  const fullscreen = () => {
    if (isFullscreen.value) {
      document.exitFullscreen();
    } else {
      if(root.value)
        root.value.requestFullscreen();
    }
  };
  const setupFullscreenListener = () => {
    document.addEventListener("fullscreenchange", () => {
      isFullscreen.value = document.fullscreenElement === root.value;
    });
  };
  const onWheel = (event: WheelEvent) => {
    if (event.deltaY > 0) {
      navigate(true);
    } else if (event.deltaY < 0) {
      navigate(false);
    }
  };

  onMounted(setupFullscreenListener);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "components__cnt-slide_show",
    onContextmenu: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
    tabindex: "-1",
    onKeydown: [
      _cache[6] || (_cache[6] = _withKeys(($event: any) => (navigate(true)), ["right"])),
      _cache[7] || (_cache[7] = _withKeys(($event: any) => (navigate(false)), ["left"]))
    ],
    onWheel: _withModifiers(onWheel, ["prevent"])
  }, [
    (notAuthorized.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("a", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (navigate(false)))
              }, "Zurück"),
              _createElementVNode("a", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (navigate(true)))
              }, "Weiter")
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(currentSlidePosition.value) + " / " + _toDisplayString(totalSlides.value), 1),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("input", {
                placeholder: "zu Seite",
                type: "number",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputValue).value = $event)),
                onKeyup: _withKeys(navigateAbsolute, ["enter"])
              }, null, 544), [
                [_vModelText, inputValue.value]
              ]),
              _createElementVNode("i", {
                title: "Vollbild",
                onClick: fullscreen,
                class: _normalizeClass(classFullscreenIcon.value)
              }, null, 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("img", {
              src: currentSlide.value.image.url,
              onContextmenu: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
              onDragstart: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
            }, null, 40, _hoisted_11)
          ])
        ], 64))
  ], 544))
}
}

})